import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'

export default {
  name: 'intern',
  components: {
    SharedHeader,
    SharedFooter
  },
  computed: {
    isSignedIn () {
      return this.$store.getters.isSignedIn
    },
    user () {
      return this.$store.getters.user
    },
    api () {
      return this.$store.getters.api
    },
    env () {
      return this.$store.getters.env
    },
    avatar () {
      return this.$store.getters.avatar
    }
  },
  data () {
    return {
      loading: true,
      updating: false,
      searching: false,
      list: [],
      pagination: {
        page_size: 15,
        offset: 0
      },
      like: false,
      orderOptions: [
        { text: '新着', value: 1 }
      ],
      orderSelect: 1,
      keyword: ''
    }
  },
  mounted () {
    this.loading = true
    if (this.$route.query.keyword) this.keyword = this.$route.query.keyword
    if (this.$route.query.like) this.like = this.$route.query.like
    this.fetchIntern()
  },
  methods: {
    getAvatar (avatarId) {
      return `${this.env.S3}/student/avatar/${avatarId}.png`
    },
    onLikeFilter () {
      this.like = true
    },
    fetchIntern () {
      this.updating = true

      let additionalParams = {
        queryParams: {
          type: 'list',
          page_size: this.pagination.page_size,
          page_offset: this.pagination.offset
        }
      }

      if (this.keyword) additionalParams.queryParams.keyword = this.keyword
      if (this.like) additionalParams.queryParams.like = this.like

      this.$apig.get(this.api.INTERN, {}, additionalParams, {}, !this.isSignedIn)
        .then(response => {
          this.total_count = response.data.total_count
          this.list = this.list.concat(response.data.list)
          this.pagination.offset = response.data.offset

          this.searching = false
          this.updating = false
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.updating = false
          this.loading = false
        })
    },
    search (type) {
      var query = Object.assign({}, this.$route.query)

      switch (type) {
        case 'keyword':
          if (this.keyword) {
            this.searching = true
            this.pagination.offset = 0

            let additionalParams = {
              queryParams: {
                type: 'list',
                page_size: this.pagination.page_size,
                page_offset: this.pagination.offset,
                keyword: this.keyword
              }
            }

            if (this.like) additionalParams.queryParams.like = this.like

            this.$apig.get(this.api.INTERN, {}, additionalParams, {}, !this.isSignedIn)
              .then(response => {
                this.total_count = response.data.total_count
                this.list = response.data.list
                this.pagination.offset = response.data.offset
                query.keyword = this.keyword
                this.$router.push({query})

                this.searching = false
              })
              .catch(err => {
                console.log(err)
                this.searching = false
              })
          } else if (this.$route.query.keyword) {
            this.searching = true
            this.pagination.offset = 0
            delete query.keyword
            this.$router.push({query})
            this.list = []
            this.fetchIntern()
          }
          break
        case 'like':
          if (this.like) {
            this.searching = true
            this.pagination.offset = 0

            let additionalParams = {
              queryParams: {
                type: 'list',
                page_size: this.pagination.page_size,
                page_offset: this.pagination.offset,
                like: this.like
              }
            }

            if (this.keyword) additionalParams.queryParams.keyword = this.keyword

            this.$apig.get(this.api.INTERN, {}, additionalParams, {}, !this.isSignedIn)
              .then(response => {
                this.total_count = response.data.total_count
                this.list = response.data.list
                this.pagination.offset = response.data.offset
                query.like = this.like
                this.$router.push({query})

                this.searching = false
              })
              .catch(err => {
                console.log(err)
                this.searching = false
              })
          } else {
            this.searching = true
            this.pagination.offset = 0
            delete query.like
            this.$router.push({query})
            this.list = []
            this.fetchIntern()
          }
          break
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/intern/intern.js